import type {
  ForwardedRef,
  FunctionComponent,
  HTMLProps,
  MutableRefObject,
  ReactNode,
} from 'react'
import { createElement } from 'react'

import classnames from 'classnames'

import type { ValidTypographyTags } from '../../../../types'
import styles from './Typography.module.scss'

export const TypographyV2: FunctionComponent<Props> = ({
  tag = 'p',
  textStyle,
  children,
  dataTestId = `typography-${textStyle}`,
  className,
  forwardRef,
  ...rest
}) => {
  const props = {
    className: classnames(`${styles[textStyle]}`, className),
    ref: forwardRef,
    'data-testid': `${dataTestId}`,
    ...rest,
  }

  return createElement(tag, props, children)
}

export type Props = {
  tag?: ValidTypographyTags
  textStyle: TypographyTokenNames
  children?: ReactNode
  dataTestId?: string
  className?: string
  forwardRef?: ForwardedRef<HTMLElement> | MutableRefObject<HTMLElement>
} & HTMLProps<HTMLElement>

export type TypographyTokenNames =
  | 'sb-text-heading-page-title'
  | 'sb-text-heading-large'
  | 'sb-text-heading-medium'
  | 'sb-text-heading-small'
  | 'sb-text-heading-subheading'
  | 'sb-text-heading-standfirst'
  | 'sb-text-heading-overline'
  | 'sb-text-body-default-regular'
  | 'sb-text-body-default-strong'
  | 'sb-text-body-default-x-strong'
  | 'sb-text-body-small-regular'
  | 'sb-text-body-x-small-regular'
  | 'sb-text-interface-heading-large'
  | 'sb-text-interface-heading-medium'
  | 'sb-text-interface-heading-small'
  | 'sb-text-interface-heading-subheading'
  | 'sb-text-interface-body-default-regular'
  | 'sb-text-interface-body-default-strong'
  | 'sb-text-interface-body-default-x-strong'
  | 'sb-text-interface-body-small-regular'
  | 'sb-text-interface-body-small-strong'
  | 'sb-text-interface-body-x-small-regular'
  | 'sb-text-component-badge'
